import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { registerPassoServiceWorker } from "./platform/pwa/registerServiceWorker";
import "./styles/global.css";

const root = document.querySelector<HTMLDivElement>("#root");

if (root === null) {
  throw new Error("Passo could not find its application root.");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if (import.meta.env.PROD) {
  registerPassoServiceWorker();
}
